export default {
  small: 'sm'
};